import { Component, OnInit, ViewChild,ViewEncapsulation, TemplateRef } from '@angular/core';
import { ModalDirective, ModalModule,BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ProductionOrderService } from '../../services/productionOrders.service';
import { CountriesService } from '../../services/countries.service';
import { LoadService } from '../../services/load.service';
import { ClientsService } from '../../services/clients.service';
import { ProductsService } from '../../services/products.service';
import { EspecificationService } from '../../services/especification.service';
import { ClientsSpecificationsService } from '../../services/clientsSpecifications.service';
import { ProductionOrderProductsService } from '../../services/productionOrdersProducts.service';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { ProductionOrder } from '../../model/ProductionOrder';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { listLocales } from 'ngx-bootstrap/chronos';
import { FilterUrlService } from '../../services/filter-url.service';
import { NgOption } from '@ng-select/ng-select';

@Component({
  selector: 'ordenproduccion',
  templateUrl: './ordenproduccion.component.html',
  styleUrls: ['./ordenproduccion.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class OrdenproduccionComponent implements OnInit {
  @ViewChild(ModalDirective) public lgModal: ModalDirective;
  public modalRef: BsModalRef;
  public op_a_cerrar:any;
  public load:number;
  public primeracarga:boolean;
  public isopen:boolean;
  public alert:string;
  public data_list:any;
  public links: any;
  public meta: any;
  public title:string;
  public isNew:boolean;
  public signupForm:FormGroup;
  public item_to_update:number;
  public countries:any;
  public clients:any;
  public country:any;
  public products:any;
  public allproducts:any;
  public clientspecification:any;
  public sumkilos:number;
  public alertaPeso:string;
  public details:boolean;
  public op : any;
  public matrixpackinglist : any [];
  public matrixpackinglisttitles : any[];
  public matrixpackinglistproducts : any[];
  public settings = {
    columns:{
      number:{header:"Orden de Producción", type:"text",filter: { visible:true, default:'asc' }},
      purchase_order_number: { header: "Orden de Compra", type:"text", filter: { visible:false, default:'asc' } },
      purchase_order_date: { header: "Fecha Orden de Compra", type:"date",filter: { visible:true, default:'asc' }},
      dispatch_date: {header: "Fecha Despacho",type:"date",filter: { visible:true, default:'asc' }},
      client_id: {
        header: "Cliente",
        type: "obj",
        tipo:"client",
        path:"relationships.client.data.attributes.name",
        filter: { visible:true,  id_type:'number', default:'asc', type:'dd' },
      },
      country_destination_id: {
        header: "Pais",
        type:"obj",
        tipo:"country",
        path:"relationships.country.data.attributes.name",
        filter: { visible:true,  id_type:'number', default:'asc', type:'dd' },
      },
      quantity: { header: "Cantidad", type:"text", filter: { visible:false, default:'asc' } },
      status_id: {
        header: "Estado",
        type:"obj",
        tipo:"status",
        path:"relationships.status.data.attributes.name",
        filter: { visible:true,  id_type:'number', default:'asc', type:'dd' },
      },
    },
    actions:{
      edit: true,
      view: true,
      delete: false,
      close:true,
    }
  };

  constructor(private _productionOrderProductsService:ProductionOrderProductsService,
    private _clientspecificationService:ClientsSpecificationsService,
    private _especificationService:EspecificationService ,
    private _productsService:ProductsService ,
    private _clientsService:ClientsService,
    private _productionorderService:ProductionOrderService,
    private _countriesService:CountriesService,
    private _loaddata: LoadService,
    private _localeService: BsLocaleService,
    private _filter: FilterUrlService,
    private modalService: BsModalService) {
    this.isNew = true;
    this.isopen = false;
    this.sumkilos = 0;
    this.alert = "";
    this.country = "";
    this.alertaPeso = "";
    this.primeracarga = false;
    this.details = false;
    this.op = [];
    this.op_a_cerrar = null;
  }


  ngOnInit() {
    this.matrixpackinglist = [];
    this.matrixpackinglisttitles = [];
    this.matrixpackinglistproducts = [];
    this.alert = 'Creando formularios.';
    this.isopen = true;
    this._loaddata.loadChange(15);
    this._localeService.use('es');
    this._filter.filterFirstLoad(this.settings);
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this.signupForm = new FormGroup({
      'id': new FormControl("-1",Validators.required),
      'ordendeproduccion': new FormControl(null,Validators.required),
      'ordendecompra': new FormControl(''),
      'fechaordendecompra': new FormControl(null,Validators.required),
      'cliente': new FormControl("1",Validators.required),
      'pais': new FormControl("1",Validators.required),
      'contacto': new FormControl(''),
      'cantidad': new FormControl(0,Validators.required),
      'fechadespacho': new FormControl(null,Validators.required),
      'observaciones': new FormControl(''),
      'estado': new FormControl(1,Validators.required),
      'especificacion': new FormControl(null,Validators.required),
      'generica': new FormControl(false),
      'producto':new FormControl(),
      'productos':new FormArray([])
    });
    this.loadCountries();
  }

  loadCountries(){
    let that = this;
    this.alert = "Cargando lista de paises."
    this._loaddata.loadChange(35);
    this._countriesService.getAll().subscribe((response:any) => {
      this.countries = response.data;

      let data = this.countries;
      let paises:string = "{";
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          paises+='"'+data[key].id+'":"'+data[key].attributes.name+'",';
        }
      }
      paises = paises.slice(0,-1);
      paises+="}";
      this.settings.columns.country_destination_id.filter['data'] = paises;

      setTimeout(function(){
        that.loadClients();
      },100);
    },
    (error) => {
      this.showError(error.error.error);
    });
  }

  loadClients(){
    let that = this;
    this.alert = "Cargando lista de clientes."
    this._loaddata.loadChange(55);
    this._clientsService.getAll().subscribe((response:any) => {
      this.clients = response.data;
      let data = response.data;
      let clientes:string = "{";
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          clientes+='"'+data[key].id+'":"'+data[key].attributes.name+'",';
        }
      }
      clientes = clientes.slice(0,-1);
      clientes+="}";
      this.settings.columns.client_id.filter['data'] = clientes;
      setTimeout(function(){
        that.loadProducts();
      },100);
    },
    (error) => {
      this.showError(error.error.error);
    });
  }

  loadProducts(){
    let that = this;
    let peso = '';
    this.alert = "Cargando lista de productos."
    this._loaddata.loadChange(75);

    this._productsService.getAll().subscribe(
      (response:any) => {
        //console.log("respuesta de productos: ",response);
        this.products = [];

        for(let prod of response.data){
          peso = 'Sin Peso';
          if(prod.relationships.properties.data.length > 0){
            peso = prod.relationships.properties.data['9'].attributes.name;
          }
          this.products = [...this.products,{ id: parseInt(prod.id), code: prod.attributes.code,codigo:prod.attributes.code,peso:peso}];
        }

        //console.log("productos: ",this.products);

        this.allproducts = [...this.products];

        setTimeout(function(){
          that.loadStatus();
        },100);
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  loadStatus(){
    let that = this;
    this.alert = "Cargando tipos de estados de OP."
    this._loaddata.loadChange(80);

    this._productionorderService.getAllStatusFromOP().subscribe(
      (response:any) => {
        //console.log(response);

        let data = response.data;
        let estados:string = "{";
        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            estados+='"'+data[key].id+'":"'+data[key].attributes.name+'",';
          }
        }
        estados = estados.slice(0,-1);
        estados+="}";
        this.settings.columns.status_id.filter['data'] = estados;

        setTimeout(function(){
          that.loadData();
        },100);
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  loadDataFiltered(filters){
    this.details = false;
    this.isopen = true;
    this.alert = "Cargando información."
    this._loaddata.loadChange(50);
    this._productionorderService.getDataFiltered(filters)
    .subscribe(
      (response:any) =>{
        this.cleanForm();
        this.data_list = response.data;
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert = "Carga correcta."
        this.isopen =true;
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        if(error.status == 0){
          this.alert = 'Busqueda sin resultados.';
          this.isopen = true;
        }
        else{
          this.showError(error.error.error);
        }
      }
    );
    this.onClosedAutomatic();
  }

/**
 * Trae las especificaciones de un cliente
 * @param id del cliente
 */
 loadClientSpecification():void{
   this._clientspecificationService.getAll(this.signupForm.get('cliente').value).subscribe(
     (response:any) => {
       this.clientspecification = response.data;
       if(this.clientspecification.length != 0){
         this.signupForm.patchValue({
           'especificacion':this.clientspecification[0].id
         })
       }
     },
     (error) => {
       this.showError(error.error.error);
     }
   );
 }

  loadData(){
    this.details = false;
    this.alert = 'Cargando ordenes de producción.';
    this.isopen = true;
    this._loaddata.loadChange(90);
    let that = this;

    this._productionorderService.get().subscribe(
      (response:any) => {
        this.data_list = response.data;
        //console.log("DATA AL CARGAR: ", this.data_list);
        this.links = response.links;
        this.meta = response.meta;

        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }

        this._loaddata.loadChange(100);
        this.alert = "Carga Correcta.";
        this.onClosedAutomatic();
        setTimeout(function(){
          that.isopen = false;
        },5000);
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  saveForm(){
    this.details = false;
    this.alert = "Generando Orden de Producción.";
    this.isopen = true;
    this._loaddata.loadChange(30);
    let prov = this._productionorderService.transformData(this.signupForm.value);
    let prov2 = '';

    if(this.signupForm.get('generica').value == false){
      prov2 = this._productionOrderProductsService.transformData(this.signupForm.get('productos'));
    }
    else{
      prov2 = this._productionOrderProductsService.transformData2(this.products,99999,1);
    }

    this._productionorderService.save(prov).subscribe(
      (response:any) =>{
        //console.log("ID de la orden nueva", response.id);
        this._productionOrderProductsService.save(prov2,response.id).subscribe(
          (response:any) =>{
            this._loaddata.loadChange(60);
            this.hideChildModal();
            this.loadData();
          },
          (error) => {
            this.showError(error.error.error);
          }
        );
    },
    (error) => {
      this.showError(error.error.error);
    });
  }

  updateForm(){
    this.details = false;
    this.alert = "Actualizando orden de producción.";
    this.isopen = true;
    this._loaddata.loadChange(35);

    let prov = this._productionorderService.transformData(this.signupForm.value);
    let prov2 = '';
    let url = this.data_list[this.item_to_update]['links'].self;
    //console.log("URL ACTUALIZAR: ", url);

    if(this.signupForm.get('generica').value == false){
      prov2 = this._productionOrderProductsService.transformData(this.signupForm.get('productos'));
    }
    else{
      prov2 = this._productionOrderProductsService.transformData2(this.products,99999,1);
    }

    this._productionorderService.update(url, prov).subscribe(
      data => {
        this._productionOrderProductsService.save(prov2,this.data_list[this.item_to_update].id).subscribe(
          (response:any) =>{
            this._loaddata.loadChange(60);
            this.alert = "Orden de producción actualizada.";
            this.onClosedAutomatic();
            this.hideChildModal();
            this.loadData();
          },
          (error) => {
            this.showError(error.error.error);
          }
        );
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  deleteItem(data) {
    this.details = false;
    this.isopen = true;
    this.alert = "Eliminando orden de producción.";
    this._loaddata.loadChange(35);
    this._productionorderService.delete(data.url).subscribe(
      (response:any) => {
          this._loaddata.loadChange(70);
          this.alert = "Orden de producción eliminada.";
          this.onClosedAutomatic();
          this.loadData();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  onChangeGeneric(){
    this.signupForm.patchValue({
      'generica':!(this.signupForm.get('generica').value)
    });
  }

  showViewForm(id:number){
    this.details = true;
    this.alert = "Cargando packing List"
    this.isopen = true;
    this._loaddata.loadChange(30);
    this.op = this.data_list[id];
    let largo;
    this.matrixpackinglist = [];
    this.matrixpackinglisttitles = [];
    this.matrixpackinglistproducts = [];
    this.matrixpackinglist.push([]);
    this.matrixpackinglisttitles.push([]);

    if(this.op.attributes.is_generic == 0){
      this._productionorderService.getPackingListFromOP(this.data_list[id].id).subscribe(
        (response:any) => {
          this._loaddata.loadChange(70);
          if(response.success.length > 0){
            largo = response.success[0].length - 6;

            this.matrixpackinglisttitles[0].push('Fecha de Extracción');
            this.matrixpackinglisttitles[0].push('Fecha de Proceso');
            this.matrixpackinglisttitles[0].push('Lote');

            for(let i = 0; i<(largo/2);i++){
              this.matrixpackinglisttitles[0].push('Cajas');
              this.matrixpackinglisttitles[0].push('Kilos');
            }

            this.matrixpackinglisttitles[0].push('Numero Cajas Totales');
            this.matrixpackinglisttitles[0].push('Peso Neto Totales');
            this.matrixpackinglisttitles[0].push('Peso Bruto Totales');

            for(let fila of response.success){
              this.matrixpackinglist = [...this.matrixpackinglist,fila];
            }

            this._productionorderService.getProductsFromOP(this.data_list[id].id).subscribe(
              (response:any) => {
                for(let producto of response.data){
                  this.matrixpackinglistproducts = [...this.matrixpackinglistproducts,{'codigo':producto.attributes.code,'calibre':producto.relationships.properties.data[10].attributes.name,'descripcion':producto.attributes.description}]
                }

                this._loaddata.loadChange(100);
                this.alert = "Carga correcta.";
                this.onClosedAutomatic();
                this.lgModal.show();
              },
              (error) => {
                this.showError(error.error.error);
              }
            )
          }
          else{
            this._loaddata.loadChange(100);
            this.alert = "No existe información.";
            this.lgModal.show();
          }
        },
        (error) => {
          this.showError(error.error.error);
        }
      );
    }
    else{
      this.alert = "Detalles no disponibles para orden de producción generica.";
      this.isopen = true;
      this._loaddata.loadChange(100);
      let that = this;
      setTimeout(function(){
        that.isopen = false;
      },5000);
    }
    this.onClosedAutomatic();
  }

  showFinalizarForm(op:any, template){
    this.op_a_cerrar = op.op;
    //console.log("OP a Cerrar: ", this.op_a_cerrar);
    //console.log("POSICION: ", op.index);
    this.openModal(template);
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  cerrarModalFinalizar(){
    this.op_a_cerrar = null;
    this.modalRef.hide();
  }

  confirmarCerrarOP(){
    //console.log("OP A CERRAR EN CONFIRMAR: ",this.op_a_cerrar);
    this._loaddata.loadChange(40);
    this.alert = "Cerrando Orden de Producción.";
    this.isopen = true;
    let id = parseInt(this.op_a_cerrar.id);
    let prov = this._productionorderService.transformDataCerrarOP(id);
    //console.log("BODY OP CERRAR ", prov);
    this._productionorderService.updateCerrarOP(prov,id).subscribe(
      data => {
        //console.log("Respuesta de Actualizacion al cerrar OP: ", data);
        this._loaddata.loadChange(100);
        this.alert = "Orden de producción Cerrada.";
        this.onClosedAutomatic();
        this.cerrarModalFinalizar();
        this.loadData();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  showCreateForm() {
    this.details = false;
    this.products = [...this.allproducts];
    this._loaddata.loadChange(30);
    this.alert = 'Calculando identificador de OP.';
    this.isopen = true;
    this.isNew = true;
    let maxid = [];
    this._productionorderService.getAll2().subscribe(
      (response:any) => {
        for(let op of response.data){
          maxid.push(op.attributes.number);
        }
        this._loaddata.loadChange(60);
        this.alert='Cargando información de clientes.';
        this._clientspecificationService.getAll(this.clients[0].id).subscribe(
          (response:any) => {
            this.clientspecification = response.data;
            let that=this;
            setTimeout(function(){
              that.sumkilos = 0;
              that.cleanForm();
              that.fillForm(-1);
              that.calculateMax(maxid);
              that.title = "Crear Orden de Producción";
              that.lgModal.show();
              that.alert='Carga correcta.';
              that._loaddata.loadChange(100);
            }, 100);
            this.onClosedAutomatic();
          },
          (error) => {
            this.showError(error.error.error);
          }
        );
      },
      (error) => {
        this.showError(error.error.error);
      }
    )
  }

  calculateMax(resp:any){
    let numeros = [];
    let ano = (new Date()).getFullYear();
    let anoinicio = '';
    let suma = -1;
    let anterior = 0;
    let actual = 0;
    let nuevonumber = 0;

    for(let op of resp){
      if(parseInt('20'+op.substring(0,2)) == ano){
        anoinicio = op.substring(0,2);
        numeros.push(parseInt(op.substring(3,7)));
      }
    }
    numeros.sort((a,b)=>a-b);


    for(let num of numeros){
      if(suma == -1){
        suma = 0;
        anterior = num;
        actual = num;
      }
      else{
        actual = num;
        suma = actual - anterior;
        if(suma > 1){
          nuevonumber = anterior + 1;
          if(nuevonumber > 0 && nuevonumber < 10){
            this.signupForm.patchValue({
              'ordendeproduccion':anoinicio+'-000'+nuevonumber
            });
          }
          else if(nuevonumber >= 10 && nuevonumber < 100){
            this.signupForm.patchValue({
              'ordendeproduccion':anoinicio+'-00'+nuevonumber
            });
          }
          else if(nuevonumber >= 100 && nuevonumber < 1000){
            this.signupForm.patchValue({
              'ordendeproduccion':anoinicio+'-0'+nuevonumber
            });
          }
          else if(nuevonumber >= 1000 && nuevonumber < 10000){
            this.signupForm.patchValue({
              'ordendeproduccion':anoinicio+'-'+nuevonumber
            });
          }
          break;
        }
        else{
          anterior = num;
        }
      }
    }
  }

  showEditForm(index) {
    this.details = false;
    this.products = [...this.allproducts];
    this.isopen = true;
    this._loaddata.loadChange(30);
    this.alert = "Cargando orden de producción."
    this.isNew = false;
    this.title = "Actualizar Orden de Producción";
    this.item_to_update = index;
    let item = this.data_list[index];

    this._clientspecificationService.getAll(item.attributes.client_id).subscribe(
      (response:any) => {
        this.clientspecification = response.data;
        let that=this;
        this._loaddata.loadChange(60);
        this.alert = "Preparando información.";

        setTimeout(function(){
          while((<FormArray>that.signupForm.get('productos')).controls.length > 0){
            (<FormArray>that.signupForm.get('productos')).removeAt((<FormArray>that.signupForm.get('productos')).controls.length - 1);
          }
          that.signupForm.patchValue({
            'id': item.id,
            'ordendeproduccion':item.attributes.number,
            'ordendecompra': item.attributes.purchase_order_number,
            'fechaordendecompra': new Date(item.attributes.purchase_order_date),
            'cliente': item.attributes.client_id,
            'pais':item.attributes.country_destination_id,
            'contacto': item.attributes.contact,
            'cantidad': item.attributes.quantity,
            'fechadespacho': new Date(item.attributes.dispatch_date),
            'observaciones': item.attributes.comment,
            'estado': item.attributes.status_id,
            'especificacion':item.attributes.specification_id,
            'producto':[],
            'generica':item.attributes.is_generic == 0 ? false : true
          });

          for(let i = 0; i < item.relationships.products.data.length; i++){
            const control = new FormGroup({
              'id':new FormControl(item.relationships.products.data[i].id),
              'codigo': new FormControl(item.relationships.products.data[i].attributes.code),
              'cajas': new FormControl(item.relationships.products.data[i].attributes.quantity),
              'kilos': new FormControl(parseFloat(item.relationships.products.data[i].relationships.properties.data[9].attributes.name)*parseFloat(item.relationships.products.data[i].attributes.quantity)),
              'kilosporcaja': new FormControl(item.relationships.products.data[i].relationships.properties.data[9].attributes.name)
            });
            (<FormArray>that.signupForm.get('productos')).push(control);
          }

          that.calculateKilosTotales();
          that._loaddata.loadChange(100);
          that.alert = "Carga correcta.";

          that.lgModal.show();
        }, 100);
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
    this.onClosedAutomatic();
  }

  onClosed(dismissedAlert: any): void {
    this.isopen = false;
  }

  /**
  * Cierra el mensaje de alerta despues de 5 segundos
  */
  onClosedAutomatic(): void {

      setTimeout(()=>{
      this.isopen = false;
    }, 3000);

  }

  selected(obj) {
    if(obj != undefined){
      let pos = 0;
      let lista = [...this.products];

      const control = new FormGroup({
        'id':new FormControl(obj.id),
        'codigo': new FormControl(obj.codigo),
        'cajas': new FormControl(0),
        'kilos': new FormControl(0),
        'kilosporcaja': new FormControl(parseFloat(obj.peso))
      });
      (<FormArray>this.signupForm.get('productos')).push(control);

      for(let prod of lista){
        if(prod.id == obj.id){
          lista.splice(pos,1);
          break;
        }
        else{
          pos += 1;
        }
      }

      this.products = [...lista];
      this.signupForm.get('producto').patchValue([]);
    }
  }

  onDeleteProductsForOP(id:number,item:any){
    this.products = [...this.products,{ id: parseInt(item.value.id), code: item.value.codigo,codigo:item.value.codigo,peso:item.value.kilosporcaja}];
    (<FormArray>this.signupForm.get('productos')).removeAt(id);
    this.calculateKilosTotales();
  }

  calculateKilos(pos:number):void{
    //console.log(((<FormArray>this.signupForm.get('productos')).value[pos].kilosporcaja)+'*'+((<FormArray>this.signupForm.get('productos')).value[pos].cajas));
    (<FormArray>this.signupForm.get('productos')).controls[pos].patchValue({
      'kilos': parseFloat(((<FormArray>this.signupForm.get('productos')).value[pos].kilosporcaja)) * parseFloat(((<FormArray>this.signupForm.get('productos')).value[pos].cajas))
    });
    this.calculateKilosTotales();
  }

  calculateKilosTotales():void{
    this.sumkilos = 0;
    for(let i = 0; i < (<FormArray>this.signupForm.get('productos')).length;i++){
      this.sumkilos += parseFloat(((<FormArray>this.signupForm.get('productos')).value[i].kilos));
    }
    if(this.sumkilos > parseFloat(this.signupForm.get('cantidad').value)){
      this.alertaPeso = "La suma de kilos supera la cantidad maxima."
    }
    else if(this.sumkilos < parseFloat(this.signupForm.get('cantidad').value)){
      this.alertaPeso = "La suma de kilos es menor a la cantidad.";
    }
    else{
      this.alertaPeso = "";
    }
  }

  hideChildModal(): void {
    this.lgModal.hide();
    this.signupForm.reset();
  }

  showError(msg:string){
    if(msg == undefined){
      this.alert = 'No tiene permisos para realizar la acción.';
    }
    else{
      this.alert = msg;
    }
    this._loaddata.loadChange(100);
    this.isopen =true;
  }

  onPrintPackingList(){
    this.alert = "Generando archivo PDF.";
    this.isopen = true;
    this._loaddata.loadChange(30);
    window.open(this._productionorderService.getPDF(this.op.id), "_blank");
    this.alert = "PDF generado.";
    this.onClosedAutomatic();
    this._loaddata.loadChange(100);
  }

  onPrintOPDetails(){
    this.alert = "Generando archivo PDF.";
    this.isopen = true;
    this._loaddata.loadChange(30);
    window.open(this._productionorderService.getPDFDetails(this.op.id), "_blank");
    this.alert = "PDF generado.";
    this.onClosedAutomatic();
    this._loaddata.loadChange(100);
  }

  /**
   * prepara el formulario para ser usado.
   */
  fillForm(obj:any):void{
    if(obj != -1){

    }
    else{
      let esp = "1";
      let cli = "1";
      let pais = "1";
      if(this.clients.length != 0){
        cli = this.clients[0].id;
        if(this.clientspecification.length != 0){
          esp = this.clientspecification[0].id;
        }
      }
      if(this.countries.length != 0){
        pais = this.countries[0].id;
      }

      this.signupForm.setValue({
        'id': "-1",
        'ordendeproduccion': null,
        'ordendecompra': '',
        'fechaordendecompra': null,
        'cliente': cli,
        'pais': pais,
        'contacto': '',
        'cantidad': 0,
        'fechadespacho': null,
        'observaciones': '',
        'estado': 1,
        'especificacion': esp,
        'generica':false,
        'producto':[],
        'productos':[]
      });
    }
  }
  /**
   * Limpia el formulario para volver a utilizarlo despues.
   */
    cleanForm():void{
      this.signupForm.reset();
      this.signupForm = new FormGroup({
        'id': new FormControl("-1",Validators.required),
        'ordendeproduccion': new FormControl(null,Validators.required),
        'ordendecompra': new FormControl(''),
        'fechaordendecompra': new FormControl(null,Validators.required),
        'cliente': new FormControl("1",Validators.required),
        'pais': new FormControl("1",Validators.required),
        'contacto': new FormControl(''),
        'cantidad': new FormControl(0,Validators.required),
        'fechadespacho': new FormControl(null,Validators.required),
        'observaciones': new FormControl(''),
        'estado': new FormControl(1,Validators.required),
        'especificacion': new FormControl(null,Validators.required),
        'generica': new FormControl(false),
        'producto':new FormControl(),
        'productos':new FormArray([])
      });
      //this.loadProductsLocal();
    }

  /**
   * Actualiza el listado por la paginacion
   * @param data nuevo listado o mensaje de error.
   */
    updateData(data:any):void{
      if(data === "Error al cargar listado."){
        this.showError(data);
      }
      else{
        this.data_list = data;
      }
    }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/ordenproduccion/ordenproduccion.component.ts